"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublicRoute = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _state = require("../../state");
var _RouteTitle = require("./RouteTitle");
var _excluded = ["restricted", "authorizedPath", "children", "title"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PublicRoute = function PublicRoute(_ref) {
  var _ref$restricted = _ref.restricted,
    restricted = _ref$restricted === void 0 ? true : _ref$restricted,
    authorizedPath = _ref.authorizedPath,
    children = _ref.children,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  var token = (0, _state.useAuthToken)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RouteTitle.RouteTitle, {
    title: title
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, props, token && restricted ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: authorizedPath
  }) : children));
};
exports.PublicRoute = PublicRoute;